/* eslint-disable */

import axios from 'axios';

const baseURL = process.env.VUE_APP_API_BASE_URL;
export default {
  state: {
    searchCourseData: {},
    getDashboardDetailsData: {}
  },
  mutations: {
    getsearchCourseByParamMutation(state, response) {
      state.searchCourseData = response;
    },
    getDashboardDetailsMutation(state, response) {
      state.getDashboardDetailsData = response;
    }
  },
  actions: {
    getsearchCourseByParam(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('courses/admin/course/?name=' + payload.id).then((response) => {
            // debugger
            context.commit('getsearchCourseByParamMutation', response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      })
    },
    getDashboardDetails(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/account/admin/dashboard/').then((response) => {
          context.commit('getDashboardDetailsMutation', response.data)
          resolve(response)
        }).catch((error) => {
          reject(error);
        })
      })
    }
  },
  getters: {
    getsearchCourseByParamState: state => state.searchCourseData,
    getDashboardDetailsState: state => state.getDashboardDetailsData
  }
}